import React from 'react';

const Overview = () => (
  <div>
    <h2 className="text-2xl font-bold mb-2">MySpace Overview</h2>
    <p className="text-gray-700">This is your personal overview. You can customize this section as needed.</p>
  </div>
);

export default Overview;
